













































import Vue from "vue";
import CustomSide from "./components/CustomSide.vue";
import _ from "lodash";
import {
  LanguageTextServiceProxy,
  IPageOfApplicationLanguageTextDto,
  ApplicationLanguageTextDto,
  LanguageDto
} from "@/service-proxies/app-v2/language.service-proxies";
import { putLangFile } from "@/api/api";

const serviceProxy = new LanguageTextServiceProxy();

export default Vue.extend({
  name: "index",
  components: {
    CustomSide
  },
  mounted() {
    console.log(this.wmHeight)
  },
  data() {
    return {
      btnLoading: false,
      bodyStyle: {
        padding: "0",
        display: "flex",
        "flex-direction": "row"
      },
      lang: {},
      dataSource: [],
      loading: false,
      totalContent: 0, // 表单列表数
      fitler: {
        // 查询条件
        size: 20,
        current: 1
      },
      columns: [
        {
          title: "模块",
          dataIndex: "source",
          key: "source",
          width: 445
        },
        {
          title: "key",
          dataIndex: "textKey",
          key: "textKey",
          width: 445,
          ellipsis: true
        },
        {
          title: "值",
          dataIndex: "textValue",
          key: "textValue",
          ellipsis: true
        }
      ],
      selectedRowKeys: []
    };
  },
  computed: {
    rowSelection() {
      const { selectedRowKeys } = this;
      return {
        onChange: (selectedRowKeys: any, selectedRows: any) => {
          console.log(selectedRowKeys, selectedRows);
        }
      };
    }
  },
  methods: {
    beforeUpload(file: any) {
      const isJson = new Promise(function(resolve, reject) {
        const keys = ["culture", "texts", "source"];
        const fileReader = new FileReader();
        fileReader.onload = function() {
          try {
            const res = <string>this.result;
            const json = JSON.parse(res);
            if (Object.keys(json).every(item => keys.indexOf(item) >= 0)) {
              resolve();
            } else {
              reject();
            }
          } catch (error) {
            reject();
          }
        };
        fileReader.onerror = function() {
          reject();
        };
        fileReader.readAsText(file);
      });
      return isJson;
    },
    async handleUpload({ file }: any) {
      const content = new FormData();
      content.append("file", file);
      this.btnLoading = true;
      const res = await putLangFile(content);
      this.btnLoading = false;
      if (res.status != 200) return;
      this.$message.success("保存成功!");
      this.loadData(this.lang);
    },
    pageIndexchange(current: number, size: number) {
      // const { pageSize: size, current } = pagination
      this.fitler = {
        size,
        current
      };
      this.loadData(this.lang);
    },

    async loadData(lang: LanguageDto) {
      this.loading = true;
      const res: IPageOfApplicationLanguageTextDto = await serviceProxy.pageList(
        lang.name,
        this.fitler.current,
        this.fitler.size
      );
      this.totalContent = Number(res.total) || 0;
      this.dataSource = res.records || [];
      this.loading = false;
    },
    onChoose(lang: LanguageDto) {
      this.loadData(lang);
      this.lang = lang;
    }
  }
});
